export default __webpack_public_path__ + "static/media/external-link.d168407e.svg";